import type { Origin } from "../../../../domain/common/Origin";

function ifcReal(n: number, decimals = 6): string {
  if (!Number.isFinite(n)) return "0.";
  const s = n.toFixed(decimals).replace(/\.?0+$/, "");
  return s.includes(".") ? s : `${s}.`;
}

export function createLocalPlacementAtOrigin(
  getNextEntityId: () => number,
  origin: Origin,
  parentPlacementId: number
): { localPlacementId: number; output: string } {
  const originId = getNextEntityId();
  const zAxisId = getNextEntityId();
  const xAxisId = getNextEntityId();
  const axisPlacementId = getNextEntityId();
  const localPlacementId = getNextEntityId();

  const x = Number(origin?.x ?? 0);
  const y = Number(origin?.y ?? 0);
  const z = Number(origin?.z ?? 0);

  let output = "";
  output += `#${originId}=IFCCARTESIANPOINT((${ifcReal(x)},${ifcReal(y)},${ifcReal(z)}));\n`;
  output += `#${zAxisId}=IFCDIRECTION((0.,0.,1.));\n`;
  output += `#${xAxisId}=IFCDIRECTION((1.,0.,0.));\n`;
  output += `#${axisPlacementId}=IFCAXIS2PLACEMENT3D(#${originId},#${zAxisId},#${xAxisId});\n`;
  output += `#${localPlacementId}=IFCLOCALPLACEMENT(#${parentPlacementId},#${axisPlacementId});\n`;

  return { localPlacementId, output };
}
